var checkout = {

    init: function () {

        // Step 1:  Toggle extra address fields and set required
        var $otherAddress = document.getElementById('other-address');
        if ($otherAddress !== null) {
            this.otherAddress($otherAddress);
        }

        // Step 2: toggle delivery/payment boxes
        let $deliveryForm = document.querySelector('.js-delivery');
        if($deliveryForm !== null) {
            this.deliveryForm($deliveryForm)
        }
    },

    otherAddress: function($otherAddress) {
        $otherAddress.addEventListener('change', (e) => {
            let active = e.target.checked;
            let deliveryAddressWrapper = document.getElementById('js-checkout-delivery-address');
            deliveryAddressWrapper.classList.toggle('d-none', !active);
    
            // activate/deactivate validation
            deliveryAddressWrapper.querySelectorAll('.js-required').forEach((el) => {
                el.toggleAttribute('required', active)
            });
    
            // clear fields
            if(!active) {
                deliveryAddressWrapper.querySelectorAll('input, select').forEach((el) => {
                    el.value = '';
                });   
            }
        });
    },

    deliveryForm: function($deliveryForm){
        let $inputs = $deliveryForm.querySelectorAll('input[type="radio"]');
        $inputs.forEach(($input) => {
            $input.addEventListener('change', (e) => {
                
                $inputs.forEach(($input) => {
                    let $card = $input.closest('.card'); 
                    $card.classList.toggle('card--active', $input.checked)});
                    // $card.querySelectorAll('.js-required').forEach((el) => {
                    //     el.toggleAttribute('required', $input.checked); // test
                    // });
            });
        });
    }
}

export default checkout;
